import { Component, OnInit } from '@angular/core';
import { MainService } from 'app/resources/services/main.service';
import { CartaoDeprecated } from 'app/resources/classes/cartaoDeprecated';
import { CepService } from 'app/resources/services/cep.service';
import { EnderecoResidencial, DefineBootboxId } from 'app/resources/classes';

@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  styleUrls: ['./endereco.component.css']
})
export class EnderecoComponent implements OnInit {

  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  bairroIsReadOnly: string | boolean = true;
  logradouroIsReadOnly: string | boolean = true;
  public cartao: CartaoDeprecated = new CartaoDeprecated();

  public processandoCEP: boolean;

  constructor(public mainService: MainService, public cepService: CepService) { }

  ngOnInit() {
    this.cartao = this.mainService.cartaoService.cartaoCurrent;
  }

  buscarCEP() {
    this.processandoCEP = true;

    let numero = undefined;
    let complemento = undefined;
    if (this.cartao.enderecoResidencial) {
      numero = this.cartao.enderecoResidencial.numero;
      complemento = this.cartao.enderecoResidencial.complemento;
    }

    this.cepService.findByViaCep(this.cartao.enderecoResidencial.cep)
      .subscribe(sucesso => {
        sucesso = sucesso.json();
        this.cartao.enderecoResidencial = new EnderecoResidencial({
          bairro: sucesso.bairro,
          cep: this.cartao.enderecoResidencial.cep,
          cidade: sucesso.localidade,
          logradouro: sucesso.logradouro,
          numero: '',
          uf: sucesso.uf,
          complemento: ''
        });
        this.cartao.enderecoResidencial.numero = numero;
        this.cartao.enderecoResidencial.complemento = complemento;

        this.logradouroIsReadOnly = !this.cartao.enderecoResidencial ||
          !this.cartao.enderecoResidencial.cidade || this.cartao.enderecoResidencial.logradouro;
        this.bairroIsReadOnly = !this.cartao.enderecoResidencial ||
          !this.cartao.enderecoResidencial.cidade || this.cartao.enderecoResidencial.bairro;
        this.processandoCEP = false;
      }, erro => {
        this.cartao.enderecoResidencial = new EnderecoResidencial({
          bairro: '',
          cep: this.cartao.enderecoResidencial.cep,
          cidade: '',
          logradouro: '',
          numero: '',
          uf: '',
          complemento: ''
        });
        this.processandoCEP = false;
        this.bootboxAlertComId.alerta(erro._body);
      });

  }

  public validaEnter(evento) {
    if (evento.keyCode == 13) {
      this.buscarCEP();
    }
    if (this.cartao.enderecoResidencial.cep === '' ||
      this.cartao.enderecoResidencial.cep === undefined ||
      this.cartao.enderecoResidencial.cep.length < 8) {
      this.cartao.enderecoResidencial = new EnderecoResidencial({
        bairro: '',
        cep: this.cartao.enderecoResidencial.cep,
        cidade: '',
        logradouro: '',
        numero: '',
        uf: '',
        complemento: ''
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/componentes/endereco/endereco.component.ts